import planningRecordSlice from './planningRecordSlice'
export default planningRecordSlice.reducer
